// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import ReactDatepicker from "react-datepicker";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

import ("react-datepicker/dist/react-datepicker.css")
;

var months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

var currentYear = new Date().getFullYear();

var years = Core__Array.fromInitializer(currentYear - 1900 | 0, (function (i) {
        return currentYear - i | 0;
      }));

function DateOfBirth(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var match$1 = React.useState(function () {
        return false;
      });
  var setError = match$1[1];
  var error = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsNotEligible = match$2[1];
  var isNotEligible = match$2[0];
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.dateOfBirth);
  var setDateOfBirth = match$3[1];
  var dateOfBirth = match$3[0];
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && !(dateOfBirth == null)) {
            return setError(function (param) {
                        return false;
                      });
          }
          
        }), [
        dateOfBirth,
        isNotEligible
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  var onChange = function (date) {
    var isAbove18 = (date == null) ? false : Utils$OrcaPaymentPage.checkIs18OrAbove(date);
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("dateOfBirth", loggerState);
    setDateOfBirth(function (param) {
          return date;
        });
    setIsNotEligible(function (param) {
          return !isAbove18;
        });
  };
  var errorString = error ? localeString.dateofBirthRequiredText : localeString.dateOfBirthInvalidText;
  return React.createElement("div", {
              className: "flex flex-col gap-1"
            }, React.createElement("div", {
                  className: "Label",
                  style: {
                    fontSize: themeObj.fontSizeLg,
                    fontWeight: themeObj.fontWeightNormal,
                    opacity: "0.6"
                  }
                }, localeString.dateOfBirth), React.createElement(ReactDatepicker, {
                  selected: dateOfBirth,
                  onChange: onChange,
                  showIcon: true,
                  icon: Caml_option.some(React.createElement(Icon$OrcaPaymentPage.make, {
                            name: "calander",
                            size: 13,
                            className: "!px-[6px] !py-[10px]"
                          })),
                  dateFormat: "dd-MM-yyyy",
                  renderCustomHeader: (function (val) {
                      return React.createElement("div", {
                                  className: "flex gap-4 items-center justify-center m-2"
                                }, React.createElement("select", {
                                      className: "p-1",
                                      value: val.date.getFullYear().toString(),
                                      onChange: (function (ev) {
                                          var value = ev.target.value;
                                          val.changeYear(value);
                                        })
                                    }, years.map(function (option) {
                                          return React.createElement("option", {
                                                      key: option.toString(),
                                                      value: option.toString()
                                                    }, option);
                                        })), React.createElement("select", {
                                      className: "p-1",
                                      value: Core__Option.getOr(months[val.date.getMonth()], "January"),
                                      onChange: (function (ev) {
                                          var value = ev.target.value;
                                          val.changeMonth(months.indexOf(value));
                                        })
                                    }, months.map(function (option) {
                                          return React.createElement("option", {
                                                      key: option,
                                                      value: option
                                                    }, option);
                                        })));
                    }),
                  placeholderText: localeString.dateOfBirthPlaceholderText,
                  className: "w-full border border-gray-300 rounded p-2",
                  wrapperClassName: "datepicker",
                  shouldCloseOnSelect: true
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: error || isNotEligible,
                  children: React.createElement("div", {
                        className: "Error pt-1",
                        style: {
                          color: themeObj.colorDangerText,
                          fontSize: themeObj.fontSizeSm,
                          textAlign: "left",
                          alignSelf: "start"
                        }
                      }, errorString)
                }));
}

var startYear = 1900;

var make = DateOfBirth;

export {
  months ,
  startYear ,
  currentYear ,
  years ,
  make ,
}
/*  Not a pure module */
